<ion-header>
  <ion-toolbar mode="md" color="dark">
    <ion-title>
      <ng-container>Assign a Guest</ng-container>
    </ion-title>
    <ion-buttons slot="end">
      <ion-button mode="md"
                  (click)="onCloseModal(true)">Close
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content fullscreen>
  <div class="assign-guest">
    <div class="assign-guest__label">Is this person the guest of a diner?</div>
    <div class="assign-guest__buttons">
      <ion-button mode="md"
                  color="dark"
                  (click)="onCloseModal(false, true)">Yes
      </ion-button>

      <ion-button mode="md"
                  color="dark"
                  (click)="onCloseModal(false, false)">No
      </ion-button>
    </div>
  </div>
</ion-content>